import { useEffect } from "react";
import { useHistory } from "react-router-dom";

import { captureErrorMessage, parseError } from "@/lib/helpers/captureErrorMessage";
import { showToast } from "@/providers/ToastProvider";

type AssessmentErrorProps = {
  definitionId: string;
  error: unknown;
};

export function AssessmentError({ definitionId, error }: AssessmentErrorProps): null {
  const history = useHistory();

  useEffect(() => {
    // Handle case where error is undefined but assessment is missing (data integrity issue)
    const actualError = error || new Error(`Assessment data not returned for ${definitionId}`);

    // Report error to LogRocket
    captureErrorMessage(parseError({ error: actualError, fallback: "Failed to load assessment" }), {
      tags: {
        component: "AssessmentErrorBoundary",
        definitionId,
        errorType: error ? "assessment_load_failure" : "missing_assessment_data",
      },
    });

    showToast([
      {
        heading: "Failed to load assessment",
        text: `Unable to load ${definitionId} assessment. Please try again later.`,
        variant: "error",
      },
    ]);

    history.push("/app/home");
  }, [definitionId, error, history]);

  return null;
}
